import React, { useContext } from 'react';
import { Card } from '@usealloy/component-library';

import WatchlistReview from '~/entities/evaluations/watchlist-review/WatchlistReview';
import JourneyApplicationContext from '~/application-review/context';
import { hasWatchlistServiceConfigured } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { useFetchedUserContext } from '~/helpers/hooks';

import { useEventTypeEvaluationsContext } from '../context';

const WatchlistMatches = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { currentAgentIsAssigned } = useContext(JourneyApplicationContext);
  const { feature_flags: featureFlags } = useFetchedUserContext();
  const hideEmptyCardsEnabled = !!featureFlags?.['remove-empty-cards'];

  // Don't render if feature flag is ON and no watchlist service configured
  // WatchlistReview handles empty state internally
  if (!shouldRenderCard(hasWatchlistServiceConfigured(evaluation), hideEmptyCardsEnabled)) {
    return null;
  }

  return (
    <Card
      header="Watchlist Matches"
      collapsible
      contentGap={0}
    >
      <WatchlistReview
        canAgentResolve={currentAgentIsAssigned}
        entityToken={evaluation.entity_token}
        evaluationToken={evaluation.evaluation_token}
        showLatestDecisions
      />
    </Card>
  );
};

export default WatchlistMatches;
